import { Button, Tag, TagLabel, useDisclosure, Wrap, WrapItem } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import TagModal from './TagModal';
import c from '../../../constant';

const TagViewer = ({ id = null, tags = [], onTagClick = (tag) => null, onCallback = () => null }) => {
	const modal = useDisclosure();
	const { t } = useTranslation();

	return (
		<>
			<Wrap borderWidth={0} borderColor="gray.100" borderRadius={c.borderRadius} spacing={2} pl={0} pr={0} pt={1} pb={1}>
				{tags?.map((tag, i) => (
					<WrapItem key={i} alignItems="center">
						<Tag 
							_hover={{ backgroundColor: 'gray.200' }} 
							borderRadius={c.borderRadius}
							whiteSpace="normal" // allow multi-line
							wordBreak="break-word" // break long words
							overflowWrap="anywhere" // modern breaking
						>
							<TagLabel
								color="blue.500"
								onMouseDown={() => onTagClick(tag)}
								_hover={{ cursor: 'pointer' }}
								pl={2}
								pr={2}
								pt={2}
								pb={2}
								whiteSpace="normal"   // override TagLabel too
								wordBreak="break-word"
								overflowWrap="anywhere"
							>
								{'#' + tag}
							</TagLabel>
						</Tag>
					</WrapItem>
				))}
				{tags?.length <= 0 && (
					<WrapItem alignItems="center">
						<Button size="sm" onMouseDown={modal?.onOpen} _focus={{ boxShadow: 'none' }}>
							{t('Input')}
						</Button>
					</WrapItem>
				)}
				{tags?.length > 0 && (
					<WrapItem alignItems="center">
						<Button size="sm" onMouseDown={modal?.onOpen} _focus={{ boxShadow: 'none' }}>
							{t('Edit')}
						</Button>
					</WrapItem>
				)}
			</Wrap>
			<TagModal id={id} tags={tags} isOpen={modal?.isOpen} onClose={modal?.onClose} onCallback={onCallback} />
		</>
	);
};

export default TagViewer;
